import FetchService from "./Shared/FetchService";
const BASE = "/aviso/walkInQueue";
export default class WalkInQueueService {
    static getLocations() {
        return FetchService.getSingleResponse(`${BASE}/locations`);
    }
    static getDepartments(locationId) {
        return FetchService.getSingleResponse(`${BASE}/departments`, { locationId });
    }
    static getServices(serviceDeliveryLocationId) {
        return FetchService.getSingleResponse(`${BASE}/services`, {
            serviceDeliveryLocationId,
        });
    }
    static getStaff(serviceDeliveryLocationId, serviceOfferingId) {
        return FetchService.getSingleResponse(`${BASE}/staff`, { serviceDeliveryLocationId, serviceOfferingId });
    }
    static enqueue(req) {
        return FetchService.postSingleResponse(`${BASE}/enqueue`, req);
    }
}
